import React from 'react';
import {NavLink} from 'react-router-dom';

import Contactbox from './Contactbox'

//images
import Amp from './img/amp.png'
import Make from './img/makecomma.png'
import Moore from './img/moore.png'
import Groove from './img/groove.png'
import Mmgletters from './img/mmg-letters.png'


const Home = () => (

      <div>


        <div id="wrap">

          <div id="info">
            <img id="make" src={Mmgletters} alt="Mmg" />
            <h1>Connecting the marketing, <br />communications and <br />technology industries.</h1>
            <Contactbox />
          </div>

          <div id="logo-container">
            <img id="make" src={Make} alt="Make" />
            <img id="moore" src={Moore} alt="Moore" /><img id="amp" src={Amp} alt="Amp" />
            <img id="groove" src={Groove} alt="Moore" />
          </div>

          <div id="footer-container">
            <NavLink exact to="/privacy">Privacy/GDPR</NavLink>
          </div>
        </div>

      </div>


);


export default Home;
